import { Role } from '../../types';
import { APP_ROLE_PARAM_KEY, rolesMapping } from '../const';

export function getRoleAppUrl(role: Role, baseUrl = window.location.origin): string {
  const appUrl = new URL(rolesMapping[role].app.url, baseUrl);
  appUrl.searchParams.set(APP_ROLE_PARAM_KEY, role);
  return appUrl.toString();
}
